// @flow
import React, { useState, useEffect } from 'react';
import type { Node } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

const useStyles = makeStyles(theme => ({
    root: {
        marginLeft: '1ch',
    },
    input: {
        width: props => props.maxLength ? `${props.maxLength}ch` : '3ch',
        textAlign: 'right',
        paddingTop: '.5em',
        paddingBottom: '.5em',
        fontSize: 14,
    },
    focused: {
        "& $notchedOutline": {
            borderColor: "yellow"
        }
    },
    // cssOutlinedInput: {
    //     '&$cssFocused $notchedOutline': {
    //         borderColor: 'lime !important',
    //     }
    // },

    notchedOutline: {
        borderWidth: '1px',
        borderColor: 'green !important'
    },
}));

type Props = $ReadOnly<{
    label: Node,
    value: ?string,
    id: ?string,
    maxLength: 3,
    onChange: (value: string) => void
}>;
function StatusBarInput({ label, value, id, maxLength, onChange }: Props) {
    const classes = useStyles({maxLength});
    const [innerValue, setInnerValue] = useState(value || '');

    useEffect(() => {
        setInnerValue(value || '');
    }, [value]);

    const handleKeyDown = (e) => {
        if(e.keyCode === 13){
            e.preventDefault();
            onChange(innerValue);
        }
    };

    const handleChange = (e) => {
        setInnerValue(e.target.value);
    };

    const handleBlur = () => {
        if(innerValue !== value) {
            onChange(innerValue);
        }
    };

    return (
        <TextField
            id={id}
            classes={{
                root: classes.root,
            }}
            value={innerValue}
            variant="filled"
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            onBlur={handleBlur}
            InputProps={{
                endAdornment: <InputAdornment position="end">{label}</InputAdornment>,
                classes: {
                    input: classes.input,
                },
                inputProps: {
                    maxLength: maxLength
                }
            }}
        />
    );
}

export default StatusBarInput;